import * as React from "react";
import type { SVGProps } from "react";
const SvgHome05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.94 10.8 19.2 9.061V4.8c0-.66-.54-1.2-1.2-1.2h-1.2c-.66 0-1.2.54-1.2 1.2v.664l-2.4-2.398c-.328-.31-.628-.666-1.2-.666s-.872.356-1.2.666L3.06 10.8c-.374.39-.66.674-.66 1.2 0 .676.518 1.2 1.2 1.2h1.2v7.2c0 .66.54 1.2 1.2 1.2h2.4a1.2 1.2 0 0 0 1.2-1.2v-4.8c0-.66.54-1.2 1.2-1.2h2.4c.66 0 1.2.54 1.2 1.2v4.8c0 .663-.063 1.2.6 1.2h3c.66 0 1.2-.54 1.2-1.2v-7.2h1.2c.682 0 1.2-.524 1.2-1.2 0-.526-.286-.81-.66-1.2Z"
    />
  </svg>
);
export default SvgHome05;
